import { allWorkspacesSelector } from "../../../utils/workspaceView";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Box, Typography, Stack, Link, Button, Drawer } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import arrowForwardIosOutlined from "../../../assets/images/chats/down_arrow.svg";
import {
  AccountLevelArkchatPermission,
  accountType,
} from "../../../utils/constant";
import useAppSelectors from "../../../customHooks/useAppSelectors";

import { crossIcon, crossIconDiv } from "../../../assets/commonFunction";
import SwitchAccount from "../../Switch/SwitchAccount";
import NewOrganisationProfile from "../../Profille/NewOrganisationProfile";
const classes = {
  drawerBody: {
    minWidth: "31.25rem",
    maxWidth: "31.25rem",
    height: "100%",
    position: "relative",
  },
  header: {
    backgroundColor: "#EAEAEA",
    color: "#0000",
    mb: "1rem",
    padding: "7px 8px",
  },
  iconDiv: crossIconDiv,
  iconn: crossIcon,
};
const MenuDrawer = ({
  setMenuDrawerOpen,
  handleClickLogout,
  setLanguageMenuOpen,
  setSettingDrawerOpen,
  setMyProfileDrawerOpen,
  setFirmProfileDrawerOpen,
  setPricingDrawerOpen,
  setSupportDrawerOpen,
  showPricing = false,
}) => {
  const allWorkspaces = useSelector(allWorkspacesSelector);
  const [isSwitchAccountDrawerOpen, setSwitchAccountDrawerOpen] =
    useState(false);
  const [isCreateNewOrgAccountDrawerOpen, setCreateNewOrgAccountDrawerOpen] =
    useState(false);
  const { currentUserData } = useAppSelectors();
  const handleMenuLogoutClick = () => {
    setMenuDrawerOpen(false);
    handleClickLogout();
  };
  return (
    <>
      <Box sx={classes.drawerBody}>
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          sx={classes.header}
        >
          <Box width={"6%"}>
            <Typography sx={classes.iconDiv}>
              <CloseIcon
                sx={classes.iconn}
                onClick={() => setMenuDrawerOpen(false)}
              />
            </Typography>
          </Box>

          <Box
            width={"92%"}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box>
              <Typography color={"black"}>
                {allWorkspaces ? "All workspaces" : currentUserData?.activeSubscriber?.subscriberFirmName}
              </Typography>
              <Typography fontSize="0.75rem" color={"black"}>
                {allWorkspaces ? "Showing every workspace" : "Currently using this account"}
              </Typography>
            </Box>

            <Box padding={"0px 8px 0px 0px"}>
              <Button
                onClick={() => setSwitchAccountDrawerOpen(true)}
                variant="outlined"
                sx={{
                  color: "#000000",
                  textTransform: "none",
                  padding: "0.1rem 0.6rem",
                  border: "1px solid #000000",
                  borderRadius: "2px",
                  ":hover": {
                    border: "1px solid #000000",
                  },
                }}
              >
                Switch
              </Button>
            </Box>
          </Box>
        </Stack>

        <>
          <Box position={"relative"} padding={"7px 8px"} minHeight={"85vh"}>
           <Box width={"85%"} margin={"auto"}>
             <Box
              overflow={"auto"}
              maxHeight={"480px"}
              width={"100%"}
              sx={{
                scrollbarWidth: "none",
                "&::-webkit-scrollbar": {
                  width: "0px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "transparent",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "transparent",
                },
              }}
            >
              <Box
                bgcolor={"transparent"}
                border={"1px solid #000000"}
                sx={{
                  cursor: "pointer",
                  borderRadius: "2px",
                }}
                mb={"0.9rem"}
                p={"0.5rem 1rem"}
                position={"relative"}
                onClick={() => {
                  setMyProfileDrawerOpen(true);
                }}
              >
                <Typography
                  color={"black"}
                  fontSize={"0.87rem"}
                  fontWeight={400}
                >
                  My Profile
                </Typography>
                <Box position={"absolute"} right={"0.4rem"} top={"20%"}>
                  <img src={arrowForwardIosOutlined} alt="logo" />
                </Box>
              </Box>

              {currentUserData?.activeSubscriber?.subscriberPriority ===
                accountType?.Organisation &&
                currentUserData?.activePermission !==
                  AccountLevelArkchatPermission?.USER && (
                  <Box
                    bgcolor={"transparent"}
                    border={"1px solid #000000"}
                    sx={{
                      cursor: "pointer",
                      borderRadius: "2px",
                    }}
                    mb={"0.9rem"}
                    p={"0.5rem 1rem"}
                    position={"relative"}
                    onClick={() => {
                      setFirmProfileDrawerOpen(true);
                    }}
                  >
                    <Typography
                      color={"black"}
                      fontSize={"0.87rem"}
                      fontWeight={400}
                    >
                      Workspace Profile
                    </Typography>
                    <Box position={"absolute"} right={"0.4rem"} top={"20%"}>
                      <img src={arrowForwardIosOutlined} alt="logo" />
                    </Box>
                  </Box>
                )}

              {showPricing && currentUserData?.accountOwner && (
                <Box
                  bgcolor={"transparent"}
                  border={"1px solid #000000"}
                  sx={{
                    cursor: "pointer",
                    borderRadius: "2px",
                  }}
                  mb={"0.9rem"}
                  p={"0.5rem 1rem"}
                  position={"relative"}
                  onClick={() => {
                    setPricingDrawerOpen(true);
                  }}
                >
                  <Typography
                    color={"black"}
                    fontSize={"0.87rem"}
                    fontWeight={400}
                  >
                    Subscription
                  </Typography>
                  <Box position={"absolute"} right={"0.4rem"} top={"20%"}>
                    <img src={arrowForwardIosOutlined} alt="logo" />
                  </Box>
                </Box>
              )}

              <Box
                bgcolor={"transparent"}
                border={"1px solid #000000"}
                sx={{
                  cursor: "pointer",
                  borderRadius: "2px",
                }}
                mb={"0.9rem"}
                p={"0.5rem 1rem"}
                position={"relative"}
                onClick={() => {
                  setSettingDrawerOpen(true);
                }}
              >
                <Typography
                  color={"black"}
                  fontSize={"0.87rem"}
                  fontWeight={400}
                >
                  Settings
                </Typography>
                <Box position={"absolute"} right={"0.4rem"} top={"20%"}>
                  <img src={arrowForwardIosOutlined} alt="logo" />
                </Box>
              </Box>

              <Link
                href={"https://www.arkchat.com/terms-of-service/"}
                underline="none"
                target="_blank"
                rel="noopener"
                color={"black"}
              >
                <Box
                  bgcolor={"transparent"}
                  border={"1px solid #000000"}
                  sx={{
                    cursor: "pointer",
                    borderRadius: "2px",
                  }}
                  mb={"0.9rem"}
                  p={"0.5rem 1rem"}
                  position={"relative"}
                >
                  <Typography
                    color={"black"}
                    fontSize={"0.87rem"}
                    fontWeight={400}
                  >
                    Terms
                  </Typography>
                  <Box position={"absolute"} right={"0.4rem"} top={"20%"}>
                    <img src={arrowForwardIosOutlined} alt="logo" />
                  </Box>
                </Box>
              </Link>

              <Box
                bgcolor={"transparent"}
                border={"1px solid #000000"}
                sx={{
                  cursor: "pointer",
                  borderRadius: "2px",
                }}
                mb={"0.9rem"}
                p={"0.5rem 1rem"}
                position={"relative"}
                onClick={() => {
                  setLanguageMenuOpen(true);
                }}
              >
                <Typography
                  color={"black"}
                  fontSize={"0.87rem"}
                  fontWeight={400}
                >
                  Language
                </Typography>
                <Box position={"absolute"} right={"0.4rem"} top={"20%"}>
                  <img src={arrowForwardIosOutlined} alt="logo" />
                </Box>
              </Box>

              <Box
                bgcolor={"transparent"}
                border={"1px solid #000000"}
                sx={{
                  cursor: "pointer",
                  borderRadius: "2px",
                }}
                onClick={() => {
                  setSupportDrawerOpen(true);
                }}
                mb={"0.9rem"}
                p={"0.5rem 1rem"}
                position={"relative"}
              >
                <Typography
                  color={"black"}
                  fontSize={"0.87rem"}
                  fontWeight={400}
                >
                  Support
                </Typography>
                <Box position={"absolute"} right={"0.4rem"} top={"20%"}>
                  <img src={arrowForwardIosOutlined} alt="logo" />
                </Box>
              </Box>
{/* 
              <Box
                bgcolor={"transparent"}
                border={"1px solid #000000"}
                sx={{
                  cursor: "pointer",
                  borderRadius: "2px",
                }}
                mb={"0.9rem"}
                p={"0.5rem 1rem"}
                position={"relative"}
                onClick={handleMenuLogoutClick}
              >
                <Typography
                  color={"black"}
                  fontSize={"0.87rem"}
                  fontWeight={400}
                >
                  Logout
                </Typography>
                <Box position={"absolute"} right={"0.4rem"} top={"20%"}>
                  <img src={arrowForwardIosOutlined} alt="logo" />
                </Box>
              </Box> */}
            </Box>
           </Box>
           <Box position={"absolute"} bottom={1} right={"16px"}>
              <Button
                onClick={handleMenuLogoutClick}
                variant="outlined"
                sx={{
                  color: "#000000",
                  textTransform: "none",
                  padding: "0.1rem 0.6rem",
                  border: "1px solid #000000",
                  borderRadius: "2px",
                  ":hover": {
                    border: "1px solid #000000",
                  },
                }}
              >
                Sign out
              </Button>
            </Box>
          </Box>
        </>
      </Box>
      <Drawer
        sx={{ zIndex: 1202 }}
        open={isSwitchAccountDrawerOpen}
        anchor={"right"}
      >
        <SwitchAccount
          setSwitchAccountDrawerOpen={setSwitchAccountDrawerOpen}
          setCreateNewOrgAccountDrawerOpen={setCreateNewOrgAccountDrawerOpen}
          setPricingDrawerOpen={setPricingDrawerOpen}
        />
      </Drawer>
      <Drawer
        sx={{ zIndex: 1202 }}
        open={isCreateNewOrgAccountDrawerOpen}
        anchor={"right"}
      >
        <NewOrganisationProfile
          setCreateNewOrgAccountDrawerOpen={setCreateNewOrgAccountDrawerOpen}
          setSwitchAccountDrawerOpen={setSwitchAccountDrawerOpen}
        />
      </Drawer>
    </>
  );
};

export default MenuDrawer;
